import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { api, formatXAF } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { RoomShare } from "@/components/LudoRoom";

export default function LudoQueuePage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [q, setQ] = useState(null);
  const qc = useQueryClient();
  useEffect(() => {
    const tick = () => api.get("/ludo/me").then(({ data }) => {
      if (data.game_id) navigate(`/ludo/game/${data.game_id}`, { replace: true });
      else if (!data.queue) navigate("/lobby?game=ludo", { replace: true });
      else setQ(data.queue);
    }).catch(() => {});
    tick();
    const id = setInterval(tick, 1500);
    const onVis = () => { if (document.visibilityState === "visible") tick(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, [navigate]);
  const leave = async () => { await api.post("/ludo/queue/leave"); qc.invalidateQueries({ queryKey: ["wallet"] }); navigate("/lobby?game=ludo"); };
  if (!q) return null;
  return (
    <div className="surface mx-auto max-w-md space-y-4 p-6 text-center rise" data-testid="ludo-queue-page">
      <Loader2 className="mx-auto h-10 w-10 animate-spin text-amber-400" />
      <h1 className="font-display text-2xl font-extrabold">{t("ludo.searching")}</h1>
      <p className="text-sm text-slate-300" data-testid="ludo-queue-info">
        Ludo · {q.players} {t("ludo.players")} · {q.mode === 2 ? t("ludo.quick") : t("ludo.classic")} · {formatXAF(q.stake)}
      </p>
      <p className="font-mono text-3xl font-bold" data-testid="ludo-queue-waiting">{q.waiting}/{q.players}</p>
      {q.room_code && <RoomShare code={q.room_code} />}
      <button type="button" onClick={leave} className="h-12 w-full rounded-full border border-white/15 font-semibold" data-testid="ludo-queue-leave-btn">
        {q.room_code && q.is_creator ? t("ludo.cancelRoom") : t("ludo.leave")}
      </button>
    </div>
  );
}
